import './Tooltip.sass';

import React, { FC, useCallback } from 'react';
import { TooltipProps } from './Tooltip.interface';
import { IcSupport28 } from '$assets';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { mainActions } from '$store/main';
import { useDispatch } from 'react-redux';
import { classNames } from '$utils';

export const Tooltip: FC<TooltipProps> = (props) => {
  const {
    scroll = false,
    iconShown = true,
    iconSize = 18,
    iconLight,
    className,
    title,
    text,
    action,
    children,
  } = props;

  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(mainActions.setPopup(null));
  }, []);

  const handleOpen = useCallback(() => {
    dispatch(
      mainActions.setPopup(
        <BottomSheet
          className="Tooltip__bottom_sheet"
          title={title}
          scroll={scroll}
          onClose={handleClose}
        >
          {text}
          {action && <div className="Tooltip__bottom_sheet__action">{action}</div>}
        </BottomSheet>,
      ),
    );
  }, []);

  return (
    <span onClick={handleOpen} className={classNames('Tooltip', className)}>
      {children}
      {iconShown && (
        <IcSupport28
          className={classNames('Tooltip__icon', { light: iconLight })}
          width={iconSize}
          height={iconSize}
        />
      )}
    </span>
  );
};
